import { render, staticRenderFns } from "./DropdownSelectMenuButton.vue?vue&type=template&id=f8209df2&scoped=true"
import script from "./DropdownSelectMenuButton.vue?vue&type=script&lang=js"
export * from "./DropdownSelectMenuButton.vue?vue&type=script&lang=js"
import style0 from "./DropdownSelectMenuButton.vue?vue&type=style&index=0&id=f8209df2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8209df2",
  null
  
)

export default component.exports